import ApiService from '../../../../../../services/ApiService'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  props: {
    filterProp: Object,
  },
  components: {},

  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      showChart: true,
      rankings: [],
      expanded: [],
      page: 1,
      totalPages: 1,
      pageSize: 7,
      headerProps: {
        sortByText: 'Ordenar por',
      },
      header: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Total O.S.',

          align: 'center',
          value: 'serviceOrder',
        },
        {
          text: 'Fornecedor',

          align: 'center',
          value: 'supplier',
        },
        {
          text: 'Avalia Tempo Atendimento',

          align: 'center',
          value: 'rateServiceTime',
        },
        {
          text: 'Avalia Serviço Concluído Satisfatória',

          align: 'center',
          value: 'rateServiceDone',
        },
        {
          text: 'Média',

          align: 'center',
          value: 'average',
        },
      ],
      mobileHeader: [
        {
          text: 'Fornecedor',

          align: 'center',
          value: 'supplier',
        },
        {
          text: 'Média',

          align: 'center',
          value: 'average',
        },
      ],
      total: 0,
    }
  },
  async created() {
    this.listRankings()
  },
  methods: {
    requestExcel() {
      this.filterProp.pageSize = 10000
      let now = new Date()
      var filename = `ranking_Supplier_${now.getDate()}-${
        now.getMonth() + 1
      }-${now.getFullYear()}.xlsx`
      this.apiService
        .post('excel/rankingSupplier', this.filterProp)
        .then((response) => {
          response = `data:application/octet-stream;base64,${response.content}`
          const link = document.createElement('a')
          link.href = response
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
    },
    async listRankings() {
      this.loading = true
      await this.apiService
        .post('reports/rankingSupplier', this.filterProp)
        .then((response) => {
          this.total = response.content.pager.totalItems
          this.totalPages = response.content.pager.totalPages
          this.showChart = response.content.objects.length > 0
          this.rankings = response.content.objects
        })
        .catch((err) => {})
      this.loading = false
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },
  },
  watch: {
    page() {
      this.filterProp.page = this.page
      this.listRankings()
    },
  },
}
